(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1712],{

/***/ 70178:
/***/ (function(module) {

!function(t,i){ true?module.exports=i():0}(this,(function(){"use strict";var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var o=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),o.call(this,t)};var r=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else r.call(this)};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s,o=this;if(f)return o.$offset=u,o.$u=0===s,o;if(0!==s){var r=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(o=this.local().add(u+r,t)).$offset=u,o.$x.$localOffset=r}else o=this.utc();return o};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||(new Date).getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return!!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return"s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)}}}));

/***/ }),

/***/ 68284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ goodsBrandCdLabel; },
/* harmony export */   "Cx": function() { return /* binding */ hashTagManufacture; },
/* harmony export */   "Hw": function() { return /* binding */ goodsFlag; },
/* harmony export */   "M2": function() { return /* binding */ getInfAgeRange; },
/* harmony export */   "PL": function() { return /* binding */ evProgDiviLabel; },
/* harmony export */   "WV": function() { return /* binding */ emphasisCdLabel; },
/* harmony export */   "Y$": function() { return /* binding */ airOrderSort; },
/* harmony export */   "bd": function() { return /* binding */ getExpectMileage; },
/* harmony export */   "j1": function() { return /* binding */ getChdAgeRange; },
/* harmony export */   "mk": function() { return /* binding */ goodsTpLabel; },
/* harmony export */   "xN": function() { return /* binding */ StartWeek; }
/* harmony export */ });
/* unused harmony export GoodsInfoStarIconNm */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

/* product 데이터 */ var hashTagManufacture = function(keyWordList, splitCount) {
    var ref, ref1;
    return (ref1 = (ref = keyWordList === null || keyWordList === void 0 ? void 0 : keyWordList.split(",", splitCount)) === null || ref === void 0 ? void 0 : ref.map(function(str) {
        return "#".concat(str);
    })) === null || ref1 === void 0 ? void 0 : ref1.join(" ");
};
var goodsTpLabel = function(goodsTp) {
    var classType = {
        P: [
            "pkg",
            "해외패키지"
        ],
        D: [
            "dmt",
            "국내여행"
        ],
        K: [
            "semi",
            "세미패키지"
        ],
        F: [
            "fit",
            "에어텔"
        ],
        H: [
            "honey",
            "허니문"
        ],
        G: [
            "golf",
            "골프"
        ],
        C: [
            "cruise",
            "크루즈"
        ],
        R: [
            "pilgrimage",
            "성지순례"
        ],
        T: [
            "air",
            "항공권"
        ],
        S: [
            "theme",
            "테마상품"
        ],
        M: [
            "biz",
            "기업단체"
        ],
        L: [
            "hotel",
            "호텔"
        ]
    };
    if (!goodsTp || !classType[goodsTp]) return null;
    return classType[goodsTp];
};
var goodsFlag = function(type) {
    var flagProps = {
        live: {
            $type: "promotion",
            $flag: "yellowlive",
            text: "옐로LIVE"
        }
    };
    if (!type || !flagProps[type]) return null;
    return flagProps[type];
};
var evProgDiviLabel = function(evProgDivi) {
    if (!evProgDivi) return null;
    var classType = {
        key03: "impending",
        key05: "deadline",
        key08: "planning",
        key07: "decided",
        key11: "decided"
    };
    if (!evProgDivi || !classType[evProgDivi]) return null;
    return classType[evProgDivi];
};
var goodsBrandCdLabel = function(goodsBrandCd) {
    var classType = {
        30: [
            "premium",
            "TOP PICK"
        ],
        40: [
            "light",
            "라이트팩"
        ],
        60: [
            "percent",
            "100% 출발"
        ]
    };
    if (!goodsBrandCd || !classType[goodsBrandCd]) return null;
    return classType[goodsBrandCd];
};
var emphasisCdLabel = function(emphasisCd) {
    var classType = {
        "1": "특가",
        // "2": "실속",
        // "3": "품격",
        // "4": "프리미엄",
        "5": "주말상품",
        // "6": "땡처리",
        "7": "선착순",
        "8": "특급호텔",
        "9": "초특급호텔",
        A: "선발권특가",
        B: "연휴",
        C: "선발권",
        D: "집중",
        E: "노옵션/노쇼핑",
        F: "할인프로모션",
        G: "비즈니스석",
        H: "담당자추천",
        I: "노쇼핑",
        J: "선착순특가",
        K: "연휴특선",
        T: "실시간항공"
    };
    if (!emphasisCd || !classType[emphasisCd]) return null;
    return classType[emphasisCd];
};
var StartWeek = function(props) {
    var outStartWdayPcnt = props.outStartWdayPcnt;
    var outStartWdayMonList = props.outStartWdayMonList.split("|");
    if (outStartWdayPcnt === 1) {
        /* 1 패턴인경우
		 * 	: 일월화수목금토 -> 매일출발
		 *  : 월수금 -> 월, 수, 금
		 * */ var wdayString = outStartWdayMonList[0].split(":")[1];
        if (wdayString === "일,월,화,수,목,금,토") return "매일출발";
        return "".concat(wdayString.split(",").join(","), "요일 출발");
    }
    return "월별 출발요일 상이";
};
var airOrderSort = function(props) {
    var trCompanyOrderArr = props.trCompanyList ? props.trCompanyList.split("|") : [];
    var airCdArr = props.airCd.split(",");
    var airNameArr = props.airName.split(",");
    var mergeArray = airNameArr.map(function(name, idx) {
        return "".concat(name, ",").concat(airCdArr[idx]);
    }).sort();
    trCompanyOrderArr.forEach(function(trComanyString) {
        var index = mergeArray.indexOf(trComanyString);
        index >= 0 && mergeArray.splice(index, 1);
    });
    return trCompanyOrderArr.concat(mergeArray);
};
var GoodsInfoStarIconNm = function(reviewScore) {
    var floorScore = Math.floor(reviewScore);
    return reviewScore - floorScore > 0.5 ? "".concat(floorScore, "_5") : floorScore;
};
/* 적립 예상 금액 */ var getExpectMileage = function(props) {
    var adtSumMileage = 0;
    if (!Array.isArray(props)) return adtSumMileage;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var adtMlgPoint = Math.round((item.adtPrice + item.airtaxAdtCost + item.bafAdtCost) * item.mlgPoint / 100);
            if (item.mlgSaveKindCd !== "R1") {
                adtMlgPoint = item.mlgPoint;
            }
            adtSumMileage += adtMlgPoint;
        // if (item.mlgDivi === 'GNL') {
        //     if (parseInt(item.evStartDt) >= 20180301) {
        //         gnlSaveDt = item.saveDt;
        //     }
        //     mlgSetNo = item.promotionNo;
        // } else {
        //     prmSaveDt = item.saveDt;
        //     mlgPromotionNo = item.promotionNo;
        // }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return adtSumMileage;
};
var getChdAgeRange = function(param) {
    var evStartDt = param.evStartDt;
    var dt = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(evStartDt);
    var startMonth = 12 * 12;
    var endMonth = 12 * 2;
    return [
        dt.add(-startMonth, "month").add(1, "day").format("YYYY.MM.DD"),
        dt.add(-endMonth, "month").format("YYYY.MM.DD"), 
    ];
};
var getInfAgeRange = function(param) {
    var evStartDt = param.evStartDt;
    var dt = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(evStartDt);
    var startMonth = 12 * 2;
    return [
        dt.add(-startMonth, "month").add(1, "day").format("YYYY.MM.DD"),
        dt.format("YYYY.MM.DD")
    ];
};



/***/ }),

/***/ 75373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Share; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_private_field_get.mjs + 1 modules
var _class_private_field_get = __webpack_require__(95315);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_private_field_init.mjs + 1 modules
var _class_private_field_init = __webpack_require__(70222);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_private_field_set.mjs + 1 modules
var _class_private_field_set = __webpack_require__(88409);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
;// CONCATENATED MODULE: ./components/common/modal/share/Share.ts







var windowOption = "toolbar=0, status=0, width=626, height=436";
var title = "노랑풍선";
var _url = /*#__PURE__*/ new WeakMap();
var Share = /*#__PURE__*/ function() {
    "use strict";
    function Share(baseUrl, parameter) {
        (0,_class_call_check/* default */.Z)(this, Share);
        (0,_class_private_field_init/* default */.Z)(this, _url, {
            writable: true,
            value: void 0
        });
        (0,_class_private_field_set/* default */.Z)(this, _url, "".concat(baseUrl).concat(/^\?/.test(parameter) ? "" : "?").concat(parameter));
    }
    var _proto = Share.prototype;
    _proto.writeText = function writeText() {
        if (ybutil_cjs/* device.isYBApp */.Uh.isYBApp()) {
            var urlObj = document.querySelector("#shortUrl");
            urlObj.focus();
            urlObj.setSelectionRange(0, 99999);
            if (document.execCommand("copy")) {
                alert("링크 복사가 완료되었습니다.\n원하는곳에 붙여넣기 해주세요.");
            }
        } else {
            navigator.clipboard.writeText((0,_class_private_field_get/* default */.Z)(this, _url)).then(function() {
                return alert("링크 복사가 완료되었습니다.\n원하는곳에 붙여넣기 해주세요.");
            });
        }
    };
    _proto.facebook = function facebook() {
        var shareUrl = "http://www.facebook.com/share.php?u=".concat(encodeURIComponent((0,_class_private_field_get/* default */.Z)(this, _url)));
        window.open(shareUrl, "sharer", windowOption);
    };
    _proto.kakaostory = function kakaostory() {
        var shareUrl = "https://story.kakao.com/s/share?url=".concat(encodeURIComponent((0,_class_private_field_get/* default */.Z)(this, _url)));
        window.open(shareUrl, "sharer", windowOption);
    };
    _proto.kakaotalk = function kakaotalk() {
        Kakao.Share.sendScrap({
            requestUrl: encodeURI((0,_class_private_field_get/* default */.Z)(this, _url))
        });
    };
    _proto.naver = function naver() {
        var shareUrl = "https://share.naver.com/web/shareView.nhn?url=".concat(encodeURI(encodeURIComponent((0,_class_private_field_get/* default */.Z)(this, _url))), "&title=").concat(encodeURIComponent(title));
        window.open(shareUrl, "sharer", windowOption);
    };
    _createClass(Share, [
        {
            key: "url",
            get: function get() {
                return (0,_class_private_field_get/* default */.Z)(this, _url);
            }
        },
        {
            key: "search",
            get: function get() {
                return (0,commonUtil/* getQueryParams */.vl)((0,_class_private_field_get/* default */.Z)(this, _url));
            }
        }
    ]);
    return Share;
}();



/***/ }),

/***/ 40070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ useTaggingClick; },
  "q": function() { return /* binding */ useTaggingLoad; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/common/commonUtil.ts + 1 modules
var commonUtil = __webpack_require__(72425);
// EXTERNAL MODULE: ./components/common/constants.ts
var constants = __webpack_require__(23234);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/common/tagging/taggingCommon.ts




// eslint-disable-next-line @typescript-eslint/no-var-requires
var utc = __webpack_require__(70178);
/** braze 일정데이터 포맷 */ var formatForTagging = function(dateString, timeString) {
    var dayDiff = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    dayjs_min_default().extend(utc);
    return dayjs_min_default()("".concat(dateString).concat(timeString !== null && timeString !== void 0 ? timeString : ""), "YYYYMMDDHHmm").add(dayDiff, "day")// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    .utc(true).toISOString();
};
var getTaggingData = function(key) {
    var tagging = window.tagging || {};
    var _key;
    return key ? (_key = tagging[key]) !== null && _key !== void 0 ? _key : null : tagging;
};
var setTaggingData = function(key, value) {
    if (!key || !value) return;
    window.tagging = window.tagging || {};
    window.tagging[key] = value;
};
/** global 데이터 */ var menuForTagging = function(paramDspSid) {
    try {
        var queryParams = (0,commonUtil/* getQueryParams */.vl)();
        var queryDspSid = paramDspSid || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.dspSid) || "";
        var globalMenuFetch = getTaggingData("useGlobalMenuBFF");
        var globalMenu = (0,_to_consumable_array/* default */.Z)(globalMenuFetch.menuLv1List).concat((0,_to_consumable_array/* default */.Z)(globalMenuFetch.menuLv2List), (0,_to_consumable_array/* default */.Z)(globalMenuFetch.menuLv3List));
        var menu = {
            dspNm: "-",
            dspMenu: "-",
            dspSid: "-"
        };
        var ref;
        // queryDspSid lv4 -> lv3 변환
        menu = (ref = globalMenu.find(function(e) {
            return e.dspSid === "".concat(queryDspSid.slice(0, -2), "00");
        })) !== null && ref !== void 0 ? ref : {
            dspNm: "-",
            dspMenu: "-",
            dspSid: "-"
        };
        var tmp = menu.dspNm, dspSidNm = tmp === void 0 ? "-" : tmp, tmp1 = menu.dspMenu, dspMenuCd = tmp1 === void 0 ? "-" : tmp1, tmp2 = menu.dspSid, dspSidCd = tmp2 === void 0 ? "-" : tmp2;
        var dspMenuNm = constants/* commonMainMenu */.uk[dspMenuCd] || "-";
        return {
            dspMenuCd: dspMenuCd,
            dspMenuNm: dspMenuNm,
            dspSidCd: dspSidCd,
            dspSidNm: dspSidNm
        };
    } catch (error) {
        return null;
    }
};
/** ```
 * amplitude -
 * 		pkg_select_promo_calender
 *  	pkg_select_promo_locallist
 * 		pkg_select_promo_dtl
 * 기획전 배너 클릭 공용
 * selectDiv: "localListFilter" |
 * ```*/ var taggingClickBanner = function(contents) {
    try {
        var title = contents.title, link = contents.link, _selectDiv = contents.selectDiv, selectDiv = _selectDiv === void 0 ? "-" : _selectDiv;
        var queryParams = (0,commonUtil/* getQueryParams */.vl)(link.split("?")[1]);
        return {
            selectDiv: selectDiv,
            promoNm: title,
            promoCd: (queryParams === null || queryParams === void 0 ? void 0 : queryParams.mstNo) || "-",
            promoLink: link
        };
    } catch (e) {
        return null;
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./components/common/goodsUtil.ts
var goodsUtil = __webpack_require__(68284);
;// CONCATENATED MODULE: ./components/common/tagging/taggingDetailPackage.ts








/** 상세 데이터 */ var detailForTagging = function(eventDetail) {
    try {
        var menuData = menuForTagging();
        var queryParams = (0,commonUtil/* getQueryParams */.vl)();
        var queryEvCd = queryParams === null || queryParams === void 0 ? void 0 : queryParams.evCd;
        var evCd = eventDetail.evCd, evNm = eventDetail.evNm, dayCnt = eventDetail.dayCnt, dayStayInfo = eventDetail.dayStayInfo, tourPatInfo = eventDetail.tourPatInfo;
        var continentCd = eventDetail.continentCd, continentNm = eventDetail.continentNm, countryCd = eventDetail.countryCd, countryNm = eventDetail.countryNm;
        var goodsCd = evCd.split("-")[0];
        // USE_EVENT_PRICE
        var useEventPrice = getTaggingData("useEventPrice");
        var totalPrice = (0,eventUtil/* getPrice */.aS)(useEventPrice);
        var ref, ref1, ref2;
        var price = {
            adtPrice: (ref = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.adtPrice) !== null && ref !== void 0 ? ref : 0,
            chdPrice: (ref1 = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.chdPrice) !== null && ref1 !== void 0 ? ref1 : 0,
            infPrice: (ref2 = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.infPrice) !== null && ref2 !== void 0 ? ref2 : 0
        };
        // USE_EVENT_MILEAGE
        var useEventMileage = getTaggingData("useEventMileage");
        var mileage = (0,goodsUtil/* getExpectMileage */.bd)(useEventMileage);
        var evStartDt = eventDetail.evStartDt, outDeprtTm = eventDetail.outDeprtTm, outArrvTm = eventDetail.outArrvTm, outDayDiff = eventDetail.outDayDiff, evArriveDt = eventDetail.evArriveDt, inDeprtTm = eventDetail.inDeprtTm, inArrvTm = eventDetail.inArrvTm, inDayDiff = eventDetail.inDayDiff;
        var outFlightDeprtTm = formatForTagging(evStartDt, outDeprtTm);
        var outFlightArrvTm = formatForTagging(evStartDt, outArrvTm, outDayDiff);
        var inFlightDeprtTm = formatForTagging(evArriveDt, inDeprtTm, -inDayDiff);
        var inFlightArrvTm = formatForTagging(evArriveDt, inArrvTm);
        var ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData), {
            prodDiv: queryEvCd ? "evCd" : "goodsCd",
            goodsCd: goodsCd,
            evCd: evCd,
            evNm: evNm,
            continentCd: continentCd,
            continentNm: continentNm,
            countryCd: countryCd,
            countryNm: countryNm,
            propCd: (ref3 = goodsCd.at(2)) !== null && ref3 !== void 0 ? ref3 : "-",
            propNm: (ref5 = constants/* commonTpCd */.S7[(ref4 = goodsCd.at(2)) !== null && ref4 !== void 0 ? ref4 : ""]) !== null && ref5 !== void 0 ? ref5 : "-",
            dayCnt: dayCnt,
            nightCnt: (ref6 = dayStayInfo === null || dayStayInfo === void 0 ? void 0 : dayStayInfo.split("박")[0]) !== null && ref6 !== void 0 ? ref6 : "-",
            tourInfo: tourPatInfo,
            outFlightCd: (ref7 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.outFlightNm) !== null && ref7 !== void 0 ? ref7 : "-",
            outFlightNm: (ref8 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.trCompanyNm) !== null && ref8 !== void 0 ? ref8 : "-",
            outFlightDeprtTm: outFlightDeprtTm !== null && outFlightDeprtTm !== void 0 ? outFlightDeprtTm : "-",
            outFlightArrvTm: outFlightArrvTm !== null && outFlightArrvTm !== void 0 ? outFlightArrvTm : "-",
            inFlightCd: (ref9 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.inFlightNm) !== null && ref9 !== void 0 ? ref9 : "-",
            inFlightNm: (ref10 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.trCompanyNm) !== null && ref10 !== void 0 ? ref10 : "-",
            inFlightDeprtTm: inFlightDeprtTm !== null && inFlightDeprtTm !== void 0 ? inFlightDeprtTm : "-",
            inFlightArrvTm: inFlightArrvTm !== null && inFlightArrvTm !== void 0 ? inFlightArrvTm : "-",
            progCd: (ref11 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.evProgDivi) !== null && ref11 !== void 0 ? ref11 : "-",
            progNm: (ref12 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.evProgDiviNm) !== null && ref12 !== void 0 ? ref12 : "-",
            recCd: (ref13 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.eventTypeCd) !== null && ref13 !== void 0 ? ref13 : "-",
            recNm: (ref14 = constants/* commonEventTypeCd */.Kr[eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.eventTypeCd]) !== null && ref14 !== void 0 ? ref14 : "-",
            adultPrice: price.adtPrice,
            childPrice: price.chdPrice,
            infantPrice: price.infPrice,
            adultSalePrice: totalPrice.adult,
            childSalePrice: totalPrice.child,
            infantSalePrice: totalPrice.infant,
            expectPoint: mileage
        });
    } catch (error) {
        return null;
    }
};
/**
 * braze, ampliture - pkg_view_dtl
 * @description 행사상세 로드
 */ var taggingLoadDetailPackage = function(eventDetail) {
    try {
        var detail = detailForTagging(eventDetail);
        var dspMenuCd = detail.dspMenuCd, dspMenuNm = detail.dspMenuNm, dspSidCd = detail.dspSidCd, dspSidNm = detail.dspSidNm, progNm = detail.progNm, evCd = detail.evCd;
        var continentNm = detail.continentNm, countryNm = detail.countryNm, outFlightNm = detail.outFlightNm, outFlightDeprtTm = detail.outFlightDeprtTm, inFlightArrvTm = detail.inFlightArrvTm;
        return {
            data: detail,
            attribute: {
                date: dayjs_min_default()().format("YYYYMMDDHHmmss"),
                dspMenuCd: dspMenuCd,
                dspMenuNm: dspMenuNm,
                dspSidCd: dspSidCd,
                dspSidNm: dspSidNm,
                evCd: evCd,
                continentNm: continentNm,
                countryNm: countryNm,
                outFlightNm: outFlightNm,
                outFlightDeprtTm: outFlightDeprtTm,
                inFlightArrvTm: inFlightArrvTm,
                progNm: progNm
            }
        };
    } catch (e) {
        return {
            data: null,
            attribute: null
        };
    }
};
/**
 * ampliture - pkg_select_dtl_change
 * @description [출발일 변경] 버튼 클릭
 */ var taggingClickEventListPopup = function(eventDetail) {
    try {
        var detail = detailForTagging(eventDetail);
        return detail;
    } catch (error) {
        return null;
    }
};
/**
 * braze, ampliture - goods_down_coupon
 * @description 사용가능쿠폰 內 [다운로드] 버튼 클릭 -> 행사상세 중단 & 쿠폰적용 모달
 */ var taggingClickCouponDown = function(coupon) {
    try {
        var evCd = coupon.evCd, selectDiv = coupon.selectDiv, couponNm = coupon.couponNm, couponNo = coupon.couponNo, discAmt = coupon.discAmt, discRate = coupon.discRate, validityFrDt = coupon.validityFrDt, validityToDt = coupon.validityToDt;
        return {
            selectDiv: selectDiv,
            evCd: evCd,
            couponCd: couponNo,
            couponNm: couponNm,
            couponValidityFrDt: validityFrDt || "-",
            couponValidityToDt: validityToDt || "-",
            couponDiscRate: discRate || 0,
            couponDiscAmt: discAmt || 0
        };
    } catch (error) {
        return null;
    }
};
/**
 * pkg_share_dtl
 * @description [공유하기] 버튼 클릭 후 -> 공유 채널 / 클릭
 */ var taggingClickShareEvent = function(eventDetail) {
    try {
        var detail = detailForTagging(eventDetail);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, detail), {
            shareCh: eventDetail.shareCh
        });
    } catch (error) {
        return null;
    }
};
/**
 * 행사코드 찜 선택
 * braze - pkg_add_evCd_wish
 * apmplitude - pkg_select_evCd_wish
 * @description [♡] 버튼 (=위시리스트) / 클릭
 */ var taggingClickEventWish = function(eventDetail) {
    try {
        var detail = detailForTagging(eventDetail);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, detail), {
            wishYn: eventDetail.wishYn
        });
    } catch (error) {
        return null;
    }
};
/**
 * braze, amplitude
 * 	click	pkg_select_evCd_pkgDtl
 * @description [예약하기] 버튼 클릭
 */ var taggingClickEventReserve = function(props) {
    try {
        var eventDetail = props.eventDetail, count = props.count, _coupon = props.coupon, coupon = _coupon === void 0 ? [] : _coupon;
        var detail = detailForTagging(eventDetail);
        // 쿠폰
        var couponCd = coupon.map(function(c) {
            return c.couponNo;
        }).join(",") || "-";
        var couponNm = coupon.map(function(c) {
            return c.couponNm;
        }).join(",") || "-";
        var couponDiscDivi = coupon.map(function(c) {
            return c.discDiviCd;
        }).join(",") || "-";
        var couponPrice = coupon.map(function(c) {
            return c.calcObj.totalPrice;
        }).join(",") || "-";
        // 인원수, 금액
        var adultCnt = count.adultCnt, childCnt = count.childCnt, infantCnt = count.infantCnt;
        var totalCnt = adultCnt + childCnt + infantCnt;
        var finPrice = detail.adultSalePrice * adultCnt + detail.childSalePrice * childCnt + detail.infantSalePrice * infantCnt;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, detail), {
            adultCnt: adultCnt,
            childCnt: childCnt,
            infantCnt: infantCnt,
            couponCd: couponCd,
            couponNm: couponNm,
            couponDiscDivi: couponDiscDivi,
            couponPrice: couponPrice,
            finPrice: finPrice,
            totalCnt: totalCnt
        });
    } catch (error) {
        return {};
    }
};

;// CONCATENATED MODULE: ./components/common/tagging/taggingGNB.ts




/**
 * amplitude - gnb_click
 * @description gnb 공통배너 클릭
 */ var taggingClickGNB = function(menu) {
    try {
        var ref = getTaggingData("useGlobalMenuBFF"), menuLv1List = ref.menuLv1List, menuLv2List = ref.menuLv2List, menuLv3List = ref.menuLv3List;
        var globalMenu = (0,_to_consumable_array/* default */.Z)(menuLv1List).concat((0,_to_consumable_array/* default */.Z)(menuLv2List), (0,_to_consumable_array/* default */.Z)(menuLv3List));
        var lv = menu.lv, dspOrder = menu.dspOrder, dspMenu = menu.dspMenu, dspNm = menu.dspNm;
        var defaultData = {
            selectDiv: lv === 0 ? 3 : lv === null || lv === void 0 ? void 0 : lv.toString(),
            menuSeq: dspOrder || 999
        };
        var findMenu = function(sid) {
            return globalMenu.find(function(v) {
                return v.dspSid === sid;
            });
        };
        // LV1
        if (lv === 1) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
            dspMenuCd: dspMenu || "-",
            dspMenuNm: dspNm || "-"
        });
        // LV2
        if (lv === 2) {
            var lv1 = findMenu(menu.dspSidHi);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                dspMenuCd: lv1.dspMenu || "-",
                dspMenuNm: lv1.dspNm || "-",
                subDspMenuCd: dspMenu,
                subDspMenuNm: dspNm
            });
        }
        if (lv === 3) {
            var isLocal = lv === 3 && menu.locTypeCd !== "T";
            var isThema = lv === 3 && menu.locTypeCd === "T";
            var lv3 = menu;
            var lv2 = findMenu(menu.dspSidHi);
            var lv11 = findMenu(lv2.dspSidHi);
            var defaultLv3Data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                dspMenuCd: (lv11 === null || lv11 === void 0 ? void 0 : lv11.dspMenu) || "-",
                dspMenuNm: (lv11 === null || lv11 === void 0 ? void 0 : lv11.dspNm) || "-",
                subDspMenuCd: lv2 === null || lv2 === void 0 ? void 0 : lv2.dspMenu,
                subDspMenuNm: lv2 === null || lv2 === void 0 ? void 0 : lv2.dspNm
            });
            // LV3
            if (isLocal) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultLv3Data), {
                dspSidCd: lv3.dspMenu || "-",
                menuNm: lv3.dspNm || "-"
            });
            // LV3 - 테마
            if (isThema) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultLv3Data), {
                themeCd: lv3.dspNm || "-",
                themeNm: lv3.dspNm || "-"
            });
        }
        // LV3 - 프로모션
        var isPromotion = menu.subDspTypeCd === "PMO";
        if (isPromotion) {
            var lv31 = menu;
            var lv2ForPromo = findMenu(menu.dspSid);
            var lv1ForPromo = findMenu(lv2ForPromo === null || lv2ForPromo === void 0 ? void 0 : lv2ForPromo.dspSidHi);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                dspMenuCd: (lv1ForPromo === null || lv1ForPromo === void 0 ? void 0 : lv1ForPromo.dspMenu) || "-",
                dspMenuNm: (lv1ForPromo === null || lv1ForPromo === void 0 ? void 0 : lv1ForPromo.dspNm) || "-",
                subDspMenuCd: lv2ForPromo === null || lv2ForPromo === void 0 ? void 0 : lv2ForPromo.dspMenu,
                subDspMenuNm: lv2ForPromo === null || lv2ForPromo === void 0 ? void 0 : lv2ForPromo.dspNm,
                promoNm: lv31.subDspNm || "-",
                promoPcUrl: lv31.dspUrl || "-",
                promoMoUrl: lv31.dspUrl || "-"
            });
        }
    } catch (error) {
        ;
        return null;
    }
};
/**
 * amplitude - pkg_select_icon_main
 * @description GNB 퀵 아이콘 클릭(PC 우측 상단)
 */ var taggingClickGNBIcon = function(option) {
    try {
        return {
            iconSeq: option.menuOrder.toString() || "-",
            pcUrl: option.pcMenuUrl || "-",
            moUrl: option.mobileMenuUrl || "-",
            menuNm_Pc: option.pcMenuNm || "-",
            menuNm_Mo: option.mobileMenuNm || "-"
        };
    } catch (error) {
        return null;
    }
};
/**
 * amplitude - pkg_search_keyword
 * @description GNB 검색바 돋보기 버튼
 */ var taggingClickGNBSearch = function(bannerText) {
    try {
        return {
            selectDiv: "searchBar",
            keyword: bannerText.keyword || "-",
            pcUrl: bannerText.pcUrl || "-",
            moUrl: bannerText.mobileUrl || "-",
            displayStartDt: bannerText.startDt || "-",
            displayEndDt: bannerText.endDt || "-"
        };
    } catch (error) {
        return null;
    }
};

// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
;// CONCATENATED MODULE: ./components/common/tagging/taggingLocalList.ts








/** 필터 데이터 */ var filterForTagging = function() {
    try {
        var queryParams = (0,commonUtil/* getQueryParams */.vl)();
        var filters = null;
        var rawData = sessionStorage.getItem("persist:$$YBSESSION_PRDT_FILTER_".concat(config_public/* default.RUNTIME_ENV */.Z.RUNTIME_ENV));
        if (rawData) {
            var parsedData = JSON.parse(rawData);
            filters = parsedData.goodsFilter ? JSON.parse(parsedData.goodsFilter)[queryParams.dspSid] : null;
        }
        // 정렬 및 필터 정보
        var sortOrderNm = "-";
        var filterDtlSearch = "-";
        var filterDeprtMn = "-";
        var filterDeprtDt = "-";
        var filterDeprtTime = "-";
        var filterDeprtCity = "-";
        var filterNight = "-";
        var filterPriceMin = "-";
        var filterPriceMax = "-";
        var filterFlight = "-";
        var filterFeature = "-";
        var filterPromo = "-";
        var filterMem = "-";
        if (filters) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
            // 정렬
            sortOrderNm = ((ref = filters.find(function(e) {
                return e.key === "sort";
            })) === null || ref === void 0 ? void 0 : ref.text) || "-";
            // 상세검색
            filterDtlSearch = ((ref1 = filters.find(function(e) {
                return e.key === "goodsNm";
            })) === null || ref1 === void 0 ? void 0 : ref1.text) || "-";
            // 출발일정
            var departureDate = (ref2 = filters.find(function(e) {
                return e.key === "outStartDateList";
            })) === null || ref2 === void 0 ? void 0 : ref2.value;
            if (departureDate && departureDate.length === 6) {
                filterDeprtMn = dayjs_min_default()(departureDate).format("YYYY-MM") || "-";
            } else {
                filterDeprtDt = dayjs_min_default()(departureDate).format("YYYY-MM-DD") || "-";
            }
            // 출발시간
            filterDeprtTime = ((ref4 = (ref3 = filters.filter(function(e) {
                return e.key === "outDeprtFgList";
            })) === null || ref3 === void 0 ? void 0 : ref3.map(function(t) {
                return t.text;
            })) === null || ref4 === void 0 ? void 0 : ref4.join(",")) || "-";
            // 출발지
            filterDeprtCity = ((ref6 = (ref5 = filters.filter(function(e) {
                return e.key === "outCityDiviNm";
            })) === null || ref5 === void 0 ? void 0 : ref5.map(function(t) {
                return t.text;
            })) === null || ref6 === void 0 ? void 0 : ref6.join(",")) || "-";
            // 여행기간
            filterNight = ((ref8 = (ref7 = filters.filter(function(e) {
                return e.key === "evDayCntList";
            })) === null || ref7 === void 0 ? void 0 : ref7.map(function(t) {
                return t.text;
            })) === null || ref8 === void 0 ? void 0 : ref8.join(",")) || "-";
            // 최소금액
            filterPriceMin = ((ref9 = filters.find(function(e) {
                return e.key === "minPrice";
            })) === null || ref9 === void 0 ? void 0 : ref9.value) || "-";
            // 최대금액
            filterPriceMax = ((ref10 = filters.find(function(e) {
                return e.key === "maxPrice";
            })) === null || ref10 === void 0 ? void 0 : ref10.value) || "-";
            // 이용교통
            filterFlight = ((ref12 = (ref11 = filters.filter(function(e) {
                return e.key === "airCd";
            })) === null || ref11 === void 0 ? void 0 : ref11.map(function(t) {
                return t.text;
            })) === null || ref12 === void 0 ? void 0 : ref12.join(",")) || "-";
            // 상품특징
            filterFeature = ((ref14 = (ref13 = filters.filter(function(e) {
                return e.key === "goodsFeaturesList";
            })) === null || ref13 === void 0 ? void 0 : ref13.map(function(t) {
                return t.text;
            })) === null || ref14 === void 0 ? void 0 : ref14.join(",")) || "-";
            // 프로모션
            filterPromo = ((ref16 = (ref15 = filters.filter(function(e) {
                return e.key === "goodsPromotion";
            })) === null || ref15 === void 0 ? void 0 : ref15.map(function(t) {
                return t.text;
            })) === null || ref16 === void 0 ? void 0 : ref16.join(",")) || "-";
            // 여행구성원
            filterMem = ((ref18 = (ref17 = filters.filter(function(e) {
                return e.key === "goodsTmember";
            })) === null || ref17 === void 0 ? void 0 : ref17.map(function(t) {
                return t.text;
            })) === null || ref18 === void 0 ? void 0 : ref18.join(",")) || "-";
        }
        return {
            sortOrderNm: sortOrderNm,
            filterDtlSearch: filterDtlSearch,
            filterDeprtMn: filterDeprtMn,
            filterDeprtDt: filterDeprtDt,
            filterDeprtTime: filterDeprtTime,
            filterDeprtCity: filterDeprtCity,
            filterNight: filterNight,
            filterPriceMin: filterPriceMin,
            filterPriceMax: filterPriceMax,
            filterFlight: filterFlight,
            filterFeature: filterFeature,
            filterPromo: filterPromo,
            filterMem: filterMem
        };
    } catch (error) {
        return null;
    }
};
/** ```
 * braze, apmplitude - pkg_view_goodsCdList
 * @description 상품전시 리스트 로드
 * ```*/ var taggingLoadLocalList = function() {
    try {
        var menuData = menuForTagging();
        var goodsByMenu = getTaggingData("useGoodsByMenu");
        var continentCd = "-";
        var continentNm = "-";
        var countryCd = "-";
        var countryNm = "-";
        if (Array.isArray(goodsByMenu)) {
            var goods = goodsByMenu[0];
            continentCd = goods.continentCd;
            continentNm = goods.continentNm;
            countryCd = goods.countryCd;
            countryNm = goods.countryNm;
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData), {
            continentCd: continentCd,
            continentNm: continentNm,
            countryCd: countryCd,
            countryNm: countryNm
        });
    } catch (e) {
        return null;
    }
};
/** ```
 * Braze, Amplitude - 상품 비교 pkg_compare_goodsCd
 * @description 상품 비교 로드
 * ```*/ var taggingLoadCompareGoods = function(compareList) {
    try {
        if (!compareList || !compareList.length) return;
        var menuData = menuForTagging();
        var filterData = filterForTagging();
        var product1 = compareList[0];
        var product2 = compareList[1];
        var product3 = compareList[2];
        // 첫번째 비교상품
        var goodsCdSeq1 = product1.goodsCd;
        var goodsNmSeq1 = product1.goodsNm;
        var countryCdSeq1 = "-";
        var countryNmSeq1 = "-";
        // 두번째 비교상품
        var goodsCdSeq2 = product2.goodsCd;
        var goodsNmSeq2 = product2.goodsNm;
        var countryCdSeq2 = "-";
        var countryNmSeq2 = "-";
        // 세번째 비교상품
        var goodsCdSeq3 = (product3 === null || product3 === void 0 ? void 0 : product3.goodsCd) || "-";
        var goodsNmSeq3 = (product3 === null || product3 === void 0 ? void 0 : product3.goodsNm) || "-";
        var countryCdSeq3 = "-";
        var countryNmSeq3 = "-";
        // USE_GOODS_BY_MENU
        var continentCd = "-";
        var continentNm = "-";
        var goodsByMenu = getTaggingData("useGoodsByMenu");
        if (Array.isArray(goodsByMenu)) {
            var p1 = goodsByMenu.find(function(e) {
                return e.goodsCd === goodsCdSeq1;
            });
            var p2 = goodsByMenu.find(function(e) {
                return e.goodsCd === goodsCdSeq2;
            });
            var p3 = goodsByMenu.find(function(e) {
                return e.goodsCd === goodsCdSeq3;
            });
            // 공통
            continentCd = p1.continentCd;
            continentNm = p1.continentNm;
            // 상품비교 1
            countryCdSeq1 = p1.countryCd;
            countryNmSeq1 = p1.countryNm;
            // 상품비교 2
            countryCdSeq2 = p2.countryCd;
            countryNmSeq2 = p2.countryNm;
            // 상품비교 3 (모바일 해당 X)
            if (p3) {
                countryCdSeq3 = p3.countryCd;
                countryNmSeq3 = p3.countryNm;
            }
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData, filterData), {
            continentCd: continentCd,
            continentNm: continentNm,
            goodsCdSeq1: goodsCdSeq1,
            goodsNmSeq1: goodsNmSeq1,
            countryCdSeq1: countryCdSeq1,
            countryNmSeq1: countryNmSeq1,
            goodsCdSeq2: goodsCdSeq2,
            goodsNmSeq2: goodsNmSeq2,
            countryCdSeq2: countryCdSeq2,
            countryNmSeq2: countryNmSeq2,
            goodsCdSeq3: goodsCdSeq3,
            goodsNmSeq3: goodsNmSeq3,
            countryCdSeq3: countryCdSeq3,
            countryNmSeq3: countryNmSeq3
        });
    } catch (e) {
        return null;
    }
};
/**
 * braze, amplitude - pkg_select_prod_list
 * @description 상품 리스트 상품 클릭 이벤트
 * @param goodsCd string
 */ var taggingClickGoods = function(props) {
    try {
        var ref, ref1, ref2, ref3;
        var goodsCd = props.goodsCd;
        var filterData = filterForTagging();
        var menuData = menuForTagging();
        var goodsByMenu = getTaggingData("useGoodsByMenu");
        var goods = goodsByMenu.find(function(v) {
            return v.goodsCd === goodsCd;
        });
        var goodsNm = goods.goodsNm, continentCd = goods.continentCd, continentNm = goods.continentNm, countryCd = goods.countryCd, countryNm = goods.countryNm, minPrice = goods.minPrice;
        var goodsEmphasisDivi = goods.goodsEmphasisDivi, themaDivi = goods.themaDivi, bestYn = goods.bestYn, rvwAvgScore = goods.rvwAvgScore;
        var goodsPromotion = (goods === null || goods === void 0 ? void 0 : goods.goodsPromotion) ? goods === null || goods === void 0 ? void 0 : (ref = goods.goodsPromotion) === null || ref === void 0 ? void 0 : ref.split(",") : undefined;
        var goodsTmember = (goods === null || goods === void 0 ? void 0 : goods.goodsTmember) ? goods === null || goods === void 0 ? void 0 : (ref1 = goods.goodsTmember) === null || ref1 === void 0 ? void 0 : ref1.split(",") : undefined;
        var featuresDivi = (ref2 = goods.goodsFeaturesDiviList) === null || ref2 === void 0 ? void 0 : ref2.split("|");
        var featuresDiviCds = [];
        var featuresDiviNms = [];
        featuresDivi === null || featuresDivi === void 0 ? void 0 : featuresDivi.forEach(function(f) {
            var nm = f.split(",")[0];
            var cd = f.split(",")[1];
            featuresDiviNms.push(nm);
            featuresDiviCds.push(cd);
        });
        var features = (ref3 = goods.goodsFeaturesList) === null || ref3 === void 0 ? void 0 : ref3.split("|");
        var featuresCds = [];
        var featuresNms = [];
        features === null || features === void 0 ? void 0 : features.forEach(function(f) {
            var nm = f.split(",")[0];
            var cd = f.split(",")[1];
            featuresNms.push(nm);
            featuresCds.push(cd);
        });
        var ref4, _themaDivi;
        return {
            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData), {
                continentCd: continentCd,
                continentNm: continentNm,
                goodsCd: goodsCd,
                goodsNm: goodsNm,
                goodsPrice: minPrice !== null && minPrice !== void 0 ? minPrice : "-",
                countryCd: countryCd,
                countryNm: countryNm
            }), filterData), {
                emphasisCd: goodsEmphasisDivi !== null && goodsEmphasisDivi !== void 0 ? goodsEmphasisDivi : "-",
                emphasisNm: (ref4 = (0,goodsUtil/* emphasisCdLabel */.WV)(goodsEmphasisDivi)) !== null && ref4 !== void 0 ? ref4 : "-",
                themaCd: themaDivi !== null && themaDivi !== void 0 ? themaDivi : "-",
                themaNm: (_themaDivi = constants/* commonThemaCd */.UJ[themaDivi]) !== null && _themaDivi !== void 0 ? _themaDivi : "-",
                bestYn: bestYn !== null && bestYn !== void 0 ? bestYn : "N",
                promoCd: Array.isArray(goodsPromotion) ? goodsPromotion[0] : "-",
                promoNm: Array.isArray(goodsPromotion) ? goodsPromotion[1] : "-",
                featuresDivCd: featuresDiviCds.join(",") || "-",
                featuresDivNm: featuresDiviNms.join(",") || "-",
                featuresCd: featuresCds.join(",") || "-",
                featuresNm: featuresNms.join(",") || "-",
                memCd: Array.isArray(goodsTmember) ? goodsTmember[0] : "-",
                memNm: Array.isArray(goodsTmember) ? goodsTmember[1] : "-",
                score: rvwAvgScore
            }),
            attribute: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData), {
                date: dayjs_min_default()().format("YYYYMMDDHHmmss"),
                goodsCd: goodsCd,
                continentNm: continentNm,
                countryNm: countryNm,
                featuresNm: featuresNms.join(","),
                memNm: Array.isArray(goodsTmember) ? goodsTmember[1] : "-",
                score: rvwAvgScore
            })
        };
    } catch (e) {
        return {
            data: null,
            attribute: null
        };
    }
};
/** ```
 * Braze - 상품공유 클릭 이벤트 pkg_share_goodsCd
 * ```*/ var taggingClickShareGoods = function(props) {
    try {
        var parameter = props.parameter, shareCh = props.shareCh;
        var filterData = filterForTagging();
        var menuData = menuForTagging();
        var queryParams = (0,commonUtil/* getQueryParams */.vl)(parameter);
        var goodsCd = queryParams.goodsCd || "-";
        var goodsNm = "-";
        // USE_GOODS_BY_MENU
        var goodsByMenu = getTaggingData("useGoodsByMenu");
        var continentCd = "-";
        var continentNm = "-";
        var countryCd = "-";
        var countryNm = "-";
        if (Array.isArray(goodsByMenu)) {
            var goods = goodsByMenu[0];
            continentCd = goods.continentCd;
            continentNm = goods.continentNm;
            countryCd = goods.countryCd;
            countryNm = goods.countryNm;
        }
        if (goodsCd && Array.isArray(goodsByMenu)) {
            // 공유하기 타겟 상품 찾기
            var goods1 = goodsByMenu.find(function(e) {
                return e.goodsCd === goodsCd;
            });
            goodsNm = (goods1 === null || goods1 === void 0 ? void 0 : goods1.goodsNm) || "-";
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuData, filterData), {
            continentCd: continentCd,
            continentNm: continentNm,
            countryCd: countryCd,
            countryNm: countryNm,
            goodsCd: goodsCd,
            goodsNm: goodsNm,
            shareCh: shareCh
        });
    } catch (e) {
        return null;
    }
};

;// CONCATENATED MODULE: ./components/common/tagging/taggingReserve.ts






/** 상세 데이터 */ var reserveForTagging = function(eventDetail) {
    try {
        var evCd = eventDetail.evCd, evNm = eventDetail.evNm, dayCnt = eventDetail.dayCnt, dayStayInfo = eventDetail.dayStayInfo, tourPatInfo = eventDetail.tourPatInfo;
        var continentCd = eventDetail.continentCd, continentNm = eventDetail.continentNm, countryCd = eventDetail.countryCd, countryNm = eventDetail.countryNm;
        var goodsCd = evCd.split("-")[0];
        // USE_EVENT_PRICE
        var useEventPrice = getTaggingData("useEventPrice");
        var totalPrice = (0,eventUtil/* getPrice */.aS)(useEventPrice);
        var ref, ref1, ref2;
        var price = {
            adtPrice: (ref = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.adtPrice) !== null && ref !== void 0 ? ref : 0,
            chdPrice: (ref1 = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.chdPrice) !== null && ref1 !== void 0 ? ref1 : 0,
            infPrice: (ref2 = useEventPrice === null || useEventPrice === void 0 ? void 0 : useEventPrice.infPrice) !== null && ref2 !== void 0 ? ref2 : 0
        };
        // USE_EVENT_MILEAGE
        var useEventMileage = getTaggingData("useEventMileage") || [];
        var mileage = (0,goodsUtil/* getExpectMileage */.bd)(useEventMileage);
        var evStartDt = eventDetail.evStartDt, outDeprtTm = eventDetail.outDeprtTm, outArrvTm = eventDetail.outArrvTm, outDayDiff = eventDetail.outDayDiff, evArriveDt = eventDetail.evArriveDt, inDeprtTm = eventDetail.inDeprtTm, inArrvTm = eventDetail.inArrvTm, inDayDiff = eventDetail.inDayDiff;
        var outFlightDeprtTm = formatForTagging(evStartDt, outDeprtTm);
        var outFlightArrvTm = formatForTagging(evStartDt, outArrvTm, outDayDiff);
        var inFlightDeprtTm = formatForTagging(evArriveDt, inDeprtTm, -inDayDiff);
        var inFlightArrvTm = formatForTagging(evArriveDt, inArrvTm);
        var ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        return {
            prodDiv: "evCd",
            goodsCd: goodsCd,
            evCd: evCd,
            evNm: evNm,
            continentCd: continentCd,
            continentNm: continentNm,
            countryCd: countryCd,
            countryNm: countryNm,
            propCd: (ref3 = goodsCd.at(2)) !== null && ref3 !== void 0 ? ref3 : "-",
            propNm: (ref5 = constants/* commonTpCd */.S7[(ref4 = goodsCd.at(2)) !== null && ref4 !== void 0 ? ref4 : ""]) !== null && ref5 !== void 0 ? ref5 : "-",
            dayCnt: dayCnt,
            nightCnt: (ref6 = Number(dayStayInfo === null || dayStayInfo === void 0 ? void 0 : dayStayInfo.split("박")[0])) !== null && ref6 !== void 0 ? ref6 : "-",
            tourInfo: tourPatInfo,
            outFlightCd: (eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.outFlightNm) ? eventDetail.outFlightNm.substring(0, 2) : "-",
            outFlightNm: (ref7 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.trCompanyNm) !== null && ref7 !== void 0 ? ref7 : "-",
            outFlightDeprtTm: outFlightDeprtTm !== null && outFlightDeprtTm !== void 0 ? outFlightDeprtTm : "-",
            outFlightArrvTm: outFlightArrvTm !== null && outFlightArrvTm !== void 0 ? outFlightArrvTm : "-",
            inFlightCd: (eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.inFlightNm) ? eventDetail.inFlightNm.substring(0, 2) : "-",
            inFlightNm: (ref8 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.trCompanyNm) !== null && ref8 !== void 0 ? ref8 : "-",
            inFlightDeprtTm: inFlightDeprtTm !== null && inFlightDeprtTm !== void 0 ? inFlightDeprtTm : "-",
            inFlightArrvTm: inFlightArrvTm !== null && inFlightArrvTm !== void 0 ? inFlightArrvTm : "-",
            progCd: (ref9 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.evProgDivi) !== null && ref9 !== void 0 ? ref9 : "-",
            progNm: (ref10 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.evProgDiviNm) !== null && ref10 !== void 0 ? ref10 : "-",
            recCd: (ref11 = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.eventTypeCd) !== null && ref11 !== void 0 ? ref11 : "-",
            recNm: (ref12 = constants/* commonEventTypeCd */.Kr[eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.eventTypeCd]) !== null && ref12 !== void 0 ? ref12 : "-",
            adultPrice: price.adtPrice,
            childPrice: price.chdPrice,
            infantPrice: price.infPrice,
            adultSalePrice: totalPrice.adult,
            childSalePrice: totalPrice.child,
            infantSalePrice: totalPrice.infant,
            expectPoint: mileage
        };
    } catch (error) {
        return null;
    }
};
/**
 * braze, amplitude
 * 	click	pkg_select_evCd_reserve
 * @description [예약하기] 버튼 클릭
 */ var taggingClickReserve = function(props) {
    try {
        var eventDetail = props.eventDetail, count = props.count, _coupon = props.coupon, coupon = _coupon === void 0 ? [] : _coupon;
        var reserve = reserveForTagging(eventDetail);
        // 쿠폰
        var couponCd = coupon.map(function(c) {
            return c.couponNo;
        }).join(",") || "-";
        var couponNm = coupon.map(function(c) {
            return c.couponNm;
        }).join(",") || "-";
        var couponDiscDivi = coupon.map(function(c) {
            return c.discDiviCd;
        }).join(",") || "-";
        var couponPrice = coupon.map(function(c) {
            return c.calcObj.totalPrice;
        }).join(",") || "-";
        // 인원수, 금액
        var adultCnt = count.adultCnt, childCnt = count.childCnt, infantCnt = count.infantCnt;
        var totalCnt = adultCnt + childCnt + infantCnt;
        var finPrice = reserve.adultSalePrice * adultCnt + reserve.childSalePrice * childCnt + reserve.infantSalePrice * infantCnt;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reserve), {
            adultCnt: adultCnt,
            childCnt: childCnt,
            infantCnt: infantCnt,
            couponCd: couponCd,
            couponNm: couponNm,
            couponDiscDivi: couponDiscDivi,
            couponPrice: couponPrice,
            finPrice: finPrice,
            totalCnt: totalCnt
        });
    } catch (error) {
        return {};
    }
};
/**
 * braze, amplitude
 *      pkg_booking_complete
 * @description 예약 완료 페이지 LOAD, REVENUE
 */ var taggingClickPrebookingComplete = function(props) {
    try {
        var eventDetail = props.eventDetail, count = props.count, _coupon = props.coupon, coupon = _coupon === void 0 ? [] : _coupon, rervNo = props.rervNo;
        var reserve = reserveForTagging(eventDetail);
        // USE_EVENT_PRICE
        var useEventPrice = getTaggingData("useEventPrice");
        // 쿠폰
        var couponCd = coupon.map(function(c) {
            return c.couponNo;
        }).join(",") || "-";
        var couponNm = coupon.map(function(c) {
            return c.couponNm;
        }).join(",") || "-";
        var couponDiscDivi = coupon.map(function(c) {
            return c.discDiviCd;
        }).join(",") || "-";
        var couponPrice = coupon.reduce(function(acc, cur) {
            return acc + cur.calcObj.totalPrice;
        }, 0); // 쿠폰 총액
        // 인원수, 금액
        var adultCnt = count.adultCnt, childCnt = count.childCnt, infantCnt = count.infantCnt;
        var totalCnt = adultCnt + childCnt + infantCnt;
        var finPrice = reserve.adultSalePrice * adultCnt + reserve.childSalePrice * childCnt + reserve.infantSalePrice * infantCnt;
        var _fixRervCd;
        var fixRervCd = (_fixRervCd = eventDetail.fixRervCd) !== null && _fixRervCd !== void 0 ? _fixRervCd : "DF";
        var _depositDivi;
        var fixRervNDType = fixRervCd === "ND" ? (_depositDivi = useEventPrice.depositDivi) !== null && _depositDivi !== void 0 ? _depositDivi : "-" : "-";
        var _depositAmt;
        var fixRervNDPrice = fixRervCd === "ND" ? (_depositAmt = useEventPrice.depositAmt) !== null && _depositAmt !== void 0 ? _depositAmt : 0 : 0;
        var data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reserve), {
            adultCnt: adultCnt,
            childCnt: childCnt,
            infantCnt: infantCnt,
            couponCd: couponCd,
            couponNm: couponNm,
            couponDiscDivi: couponDiscDivi,
            couponPrice: couponPrice,
            finPrice: finPrice,
            totalCnt: totalCnt,
            fixRervCd: fixRervCd,
            fixRervNDType: fixRervNDType,
            fixRervNDPrice: fixRervNDPrice
        });
        return {
            data: data,
            purchase: {
                productId: "pkg_prebooking_complete",
                price: finPrice,
                currencyCode: "KRW",
                quantity: totalCnt,
                purchaseProperties: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                    cat: "PKG",
                    rervNo: rervNo,
                    couponCd: couponCd,
                    couponNm: couponNm,
                    couponDiscDivi: couponDiscDivi,
                    couponPrice: couponPrice
                })
            },
            revenue: {
                productId: rervNo,
                price: finPrice,
                quantity: totalCnt,
                revenue: finPrice - couponPrice
            }
        };
    } catch (error) {
        return {};
    }
};

// EXTERNAL MODULE: ./framework/utils/logger.ts
var logger = __webpack_require__(42277);
// EXTERNAL MODULE: ./node_modules/@kit/utils/esm/index.mjs + 145 modules
var esm = __webpack_require__(6286);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/common/useTagging.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 












/** 사용할 queryKey */ var taggingQueryKeys = [
    "useGlobalMenuBFF",
    "useGoodsFilter",
    "useGoodsByMenu",
    "useEventPrice",
    "useEventMileage",
    "useCustomerMe", 
];
var common = function() {
    var ref;
    return {
        cat: "PKG",
        webCustNo: ((ref = getTaggingData("useCustomerMe")) === null || ref === void 0 ? void 0 : ref.webCustNo) || ""
    };
};
var brazeEvent = function(eventName, data) {
    data && esm/* braze.logCustomEvent */.ID.logCustomEvent(eventName, (0,_object_spread/* default */.Z)({}, common(), data));
};
var brazeAttribute = function(eventName, data) {
    data && esm/* braze.addToCustomAttributeArray */.ID.addToCustomAttributeArray(eventName, (0,_object_spread/* default */.Z)({}, common(), data));
};
var brazePurChase = function(data) {
    if (!data || !data.productId || !data.price || !data.quantity) return;
    var productId = data.productId, price = data.price, currencyCode = data.currencyCode, quantity = data.quantity, _purchaseProperties = data.purchaseProperties, purchaseProperties = _purchaseProperties === void 0 ? {} : _purchaseProperties;
    esm/* braze.logPurchase */.ID.logPurchase(productId, price, currencyCode, quantity, purchaseProperties);
};
var amplitudeTrack = function(eventName, data) {
    data && esm/* amplitude.track */.bO.track(eventName, (0,_object_spread/* default */.Z)({}, common(), data));
};
var amplitudeRevenue = function(data) {
    if (!data || !data.productId || !data.price || !data.quantity || !data.revenue) return;
    var productId = data.productId, price = data.price, quantity = data.quantity, revenue = data.revenue;
    esm/* amplitude.Revenue */.bO.Revenue().setProductId(productId).setPrice(price).setQuantity(quantity).setRevenueType("pkg").setRevenue(revenue).send();
};
var tracking = function(props) {
    var taggingName = props.taggingName, event = props.event, track = props.track, attribute = props.attribute, purchase = props.purchase, revenue = props.revenue;
    event && brazeEvent(taggingName, event);
    track && amplitudeTrack(taggingName, track);
    attribute && brazeAttribute(taggingName, attribute);
    purchase && brazePurChase(purchase);
    revenue && amplitudeRevenue(revenue);
};
var TAGGING_MAX_WAIT_MS = 2000;
var TAGGING_POLL_INTERVAL_MS = 1000;
/**
 * queryClient 패치 여부 체크. API 에러 시 null-safe.
 */ var isQueryFetched = function(queryClient) {
    try {
        // taggingQueryKeys 포함된 것만 가져오기
        var filteredQueries = queryClient.getQueriesData({}).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), queryKey = _param[0];
            return Array.isArray(queryKey) && taggingQueryKeys.includes(queryKey[0]);
        });
        var filteredQueryKeys = filteredQueries.map(function(item) {
            return item[0][0];
        });
        var _tagging;
        // window 객체에 세팅 됬는지 확인
        var windowTagging =  true ? (_tagging = window.tagging) !== null && _tagging !== void 0 ? _tagging : {} : 0;
        var windowKeys = Object.keys(windowTagging);
        var isWindowSet = filteredQueryKeys.toSorted().join() === windowKeys.toSorted().join();
        if (isWindowSet) {
            return true;
        }
        // queries 패치 여부
        var isQueriesFetched = filteredQueries.every(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), data = _param[1];
            return data;
        });
        if (isQueriesFetched) {
            // window 객체에 세팅
            filteredQueries.forEach(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), queryKey = _param[0], data = _param[1];
                var key = queryKey[0];
                var body = data === null || data === void 0 ? void 0 : data.body;
                if (key && body) setTaggingData(key, body);
            });
            return true;
        }
        return false;
    } catch (error) {
        logger/* default.error */.Z.error({
            message: "isQueryFetched error",
            error: error
        });
        return false;
    }
};
/** 준비되거나 maxWait 경과 시 onReady 호출. 단일 interval로 처리. */ var pollUntilReady = function(queryClient) {
    var onReady = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return undefined;
    }, ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _intervalMs = ref.intervalMs, intervalMs = _intervalMs === void 0 ? TAGGING_POLL_INTERVAL_MS : _intervalMs, _maxWaitMs = ref.maxWaitMs, maxWaitMs = _maxWaitMs === void 0 ? TAGGING_MAX_WAIT_MS : _maxWaitMs;
    var elapsed = 0;
    var id = setInterval(function() {
        elapsed += intervalMs;
        if (isQueryFetched(queryClient) || elapsed >= maxWaitMs) {
            clearInterval(id);
            onReady();
        }
    }, intervalMs);
    return function() {
        return clearInterval(id);
    };
};
var useTaggingLoad = function(taggingName, taggingData) {
    try {
        if (!taggingName) return;
        var taggingLoad = function() {
            var handlers = {
                // localList.page
                pkg_view_goodsCdList: function() {
                    var data = taggingLoadLocalList();
                    return {
                        event: data,
                        track: data
                    };
                },
                pkg_compare_goodsCd: function(props) {
                    var data = taggingLoadCompareGoods(props);
                    return {
                        event: data,
                        track: data
                    };
                },
                // detailpackage.page
                pkg_view_dtl: function(props) {
                    var ref = taggingLoadDetailPackage(props), data = ref.data, attribute = ref.attribute;
                    return {
                        event: data,
                        track: data,
                        attribute: attribute
                    };
                }
            };
            if (handlers[taggingName]) {
                var result = handlers[taggingName](taggingData);
                tracking((0,_object_spread/* default */.Z)({
                    taggingName: taggingName
                }, result));
            }
        };
        var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
        (0,react.useEffect)(function() {
            return pollUntilReady(queryClient, taggingLoad);
        }, [
            taggingData
        ]);
    } catch (error) {
        logger/* default.error */.Z.error({
            message: "useTaggingLoad",
            error: error
        });
    }
};
var useTaggingClick = function(taggingName, taggingData) {
    try {
        if (!taggingName) return;
        var taggingClick = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(addData) {
                var mergedData, _tmp, handlers, _tmp1, result, _tmp2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    _tmp = {};
                    mergedData = (0,_object_spread/* default */.Z)(_tmp, taggingData, addData);
                    _tmp1 = {};
                    handlers = (_tmp1.// GNB
                    gnb_click = function() {
                        return {
                            track: taggingClickGNB(mergedData)
                        };
                    }, _tmp1.pkg_select_icon_main = function() {
                        return {
                            track: taggingClickGNBIcon(mergedData)
                        };
                    }, _tmp1.pkg_search_keyword = function() {
                        return {
                            track: taggingClickGNBSearch(mergedData)
                        };
                    }, _tmp1.// banner
                    pkg_select_promo_calender = function() {
                        return {
                            track: taggingClickBanner(mergedData)
                        };
                    }, _tmp1.pkg_select_promo_locallist = function() {
                        return {
                            track: taggingClickBanner(mergedData)
                        };
                    }, _tmp1.pkg_select_promo_dtl = function() {
                        return {
                            track: taggingClickBanner(mergedData)
                        };
                    }, _tmp1.// localList.page
                    pkg_select_prod_list = function() {
                        var ref = taggingClickGoods(mergedData), data = ref.data, attribute = ref.attribute;
                        return {
                            event: data,
                            track: data,
                            attribute: attribute
                        };
                    }, _tmp1.pkg_share_goodsCd = function() {
                        var data = taggingClickShareGoods(mergedData);
                        return {
                            event: data,
                            track: data
                        };
                    }, _tmp1.// detailPackage.page
                    pkg_select_dtl_change = function() {
                        var data = taggingClickEventListPopup(mergedData);
                        return {
                            event: data,
                            track: data
                        };
                    }, _tmp1.goods_down_coupon = function() {
                        var data = taggingClickCouponDown(mergedData);
                        return {
                            event: data,
                            track: data
                        };
                    }, _tmp1.pkg_share_dtl = function() {
                        var data = taggingClickShareEvent(mergedData);
                        return {
                            event: data,
                            track: data
                        };
                    }, _tmp1.pkg_select_evCd_wish = function() {
                        var data = taggingClickEventWish(mergedData);
                        return {
                            event: data,
                            track: data
                        };
                    }, _tmp1.pkg_select_evCd_pkgDtl = function() {
                        var data = taggingClickEventReserve(mergedData);
                        return {
                            event: data,
                            track: data
                        };
                    }, _tmp1.// reserve.page
                    pkg_select_evCd_reserve = function() {
                        return {
                            track: taggingClickReserve(mergedData)
                        };
                    }, _tmp1.pkg_prebooking_complete = function() {
                        var ref = taggingClickPrebookingComplete(mergedData), data = ref.data, purchase = ref.purchase, revenue = ref.revenue;
                        return {
                            event: data,
                            track: data,
                            purchase: purchase,
                            revenue: revenue
                        };
                    }, _tmp1);
                    _tmp2 = {};
                    if (handlers[taggingName]) {
                        result = handlers[taggingName](taggingData);
                        tracking((0,_object_spread/* default */.Z)((_tmp2.taggingName = taggingName, _tmp2), result));
                    }
                    return [
                        2
                    ];
                });
            });
            return function taggingClick(addData) {
                return _ref.apply(this, arguments);
            };
        }();
        var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
        (0,react.useEffect)(function() {
            return pollUntilReady(queryClient);
        }, [
            queryClient
        ]);
        return {
            taggingClick: taggingClick
        };
    } catch (error) {
        logger/* default.error */.Z.error({
            message: "useTaggingClick",
            error: error
        });
        return {
            taggingClick: function() {
                return null;
            }
        };
    }
};


/***/ }),

/***/ 88951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 공통 코드 조회
 *   `/esntl/api/code/${groupId}`
 * parameter
 *   `groupId` 그롭 ID
 * ```*/ var key = "useCode";
var getPath = function(groupId) {
    if (!groupId) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/common/code/").concat(groupId);
};
/** ```
 * 공통 코드 조회
 *   `/esntl/api/code/${groupId}`
 * parameter
 *   `groupId` 그롭 ID
 * ```*/ var useCode = function(groupId, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(groupId)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(groupId)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useCode);



/***/ }),

/***/ 3081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key, goodsDetailAsync, goodsDetailSSR */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23234);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);





/** ```
 * 상품 정보 조회
 *   `/pkg/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var key = "useGoodsDetail";
var getPath = function(goodsCd) {
    if (!goodsCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/join-event/").concat(goodsCd);
};
/** ```
 * 상품 정보 조회
 *   `/pkg/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var goodsDetailAsync = function(goodsCd) {
    return useConfigureAxios(getPath(goodsCd), {
        method: "GET"
    });
};
/** ```
 * 상품 정보 조회
 *   `/pkg/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var goodsDetailSSR = function(goodsCd) {
    return useConfigureAxios(getPath(goodsCd), {
        method: "GET"
    });
};
/** ```
 * 상품 정보 조회
 *   `/prdt/api/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useGoodsDetail = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        placeholderData: {
            body: _COMPONENTS_common_constants__WEBPACK_IMPORTED_MODULE_0__/* .GOODS_DETAIL */ .Ev
        }
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsDetail);



/***/ }),

/***/ 92553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ goodsRecentEventAsync; }
/* harmony export */ });
/* unused harmony exports getPath, goodsRecentEventSSR */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);






var key = "useGoodsRecentEvent";
/** ```
 * 상품 예약이 가능한 첫번째 행사코드
 *   `/pkg/goods/{goodsCd}/recent-event/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var getPath = function(goodsCd, searchType, startDate) {
    if (!goodsCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/").concat(goodsCd, "/recent-event/").concat(searchType).concat(startDate ? "?startDate=".concat(startDate) : "");
};
/** ```
 *  해당 상품의 가장 빠른 행사 , 일자 , 전시된 월
 *   `/pkg/goods/{goodsCd}/recent-event/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var goodsRecentEventAsync = function(goodsCd) {
    var searchType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "amt", startDate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(getPath(goodsCd, searchType, startDate), {
        method: "GET"
    });
};
/** ```
 *  해당 상품의 가장 빠른 행사 , 일자 , 전시된 월
 *   `/pkg/goods/{goodsCd}/recent-event/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var goodsRecentEventSSR = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(goodsCd) {
        var searchType, startDate, _tmp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            searchType = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "amt", startDate = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "";
            _tmp = {};
            return [
                2,
                (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(getPath(goodsCd, searchType, startDate), (_tmp.method = "GET", _tmp))
            ];
        });
    });
    return function goodsRecentEventSSR(goodsCd) {
        return _ref.apply(this, arguments);
    };
}();
/** ```
 * 상품 예약이 가능한 첫번째 행사코드
 *   `/goods/{goodsCd}/recent-event/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var useGoodsRecentEvent = function(goodsCd) {
    var searchType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "amt", startDate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", options = arguments.length > 3 ? arguments[3] : void 0;
    return useQuery(_object_spread({
        queryKey: [
            key,
            getPath(goodsCd, searchType, startDate)
        ],
        queryFn: function() {
            return useConfigureAxios({
                url: getPath(goodsCd, searchType, startDate)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useGoodsRecentEvent)));



/***/ })

}]);